import {
  Box,
  Tooltip
} from '@chakra-ui/react'
import { ReplyIcon } from 'assets/icons'
import { COLORS } from 'utils/styles'

export const MsgFunctionBar = ({
  eventId,
  setReplyToEventId,
  whosChat
}) => {
  console.log()

  return (
    <Box
      bg={COLORS.materialDesignGray800}
      align="center"
      justify="center"
      padding="3px"
      opacity={0}
      _groupHover={{ opacity: 1 }}
      transition="opacity 0.5s"
      position="absolute"
      width="30%"
      border={`solid 1px ${COLORS.charcoalGray}`}
      borderRadius="3px"
      top="-32px"
      right={whosChat === 'me' ? '12px' : ''}
      left={whosChat === 'them' ? '12px' : ''}
    >
      <Tooltip label="Reply">
        <Box
          as="button"
          width={30}
          height={30}
          display="block"
          cursor="pointer"
          borderRadius="3px"
          onClick={() => setReplyToEventId(eventId)}
          _hover={{
            background: COLORS.charcoalGray,
            transition: 'background 0.5s'
          }}
        >
          <ReplyIcon
            height={28}
            width={28}
            stroke={COLORS.lightGray}
          />
        </Box>
      </Tooltip>
    </Box>
  )
}
